var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { Root } from '../styles';
var TextInput = function (props) {
    var id = props.id, caption = props.caption, tooltip = props.tooltip, value = props.value, _a = props.contentType, contentType = _a === void 0 ? 'text' : _a, _b = props.size, size = _b === void 0 ? 'small' : _b, _c = props.big, big = _c === void 0 ? false : _c, _d = props.suffix, suffix = _d === void 0 ? '' : _d, _e = props.inside, inside = _e === void 0 ? false : _e, _f = props.disabled, disabled = _f === void 0 ? false : _f, _g = props.button, button = _g === void 0 ? false : _g, onChange = props.onChange;
    var onValueChange = function (e) {
        var _a;
        if (onChange) {
            var val = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value;
            if (contentType === 'number') {
                if (!Number.isNaN(Number(val))) {
                    onChange(Number(val));
                }
            }
            else {
                onChange(val);
            }
        }
    };
    var inputProps = __assign({}, (suffix ? { endAdornment: React.createElement(InputAdornment, { position: "end" }, suffix) } : {}));
    return (React.createElement(Root, { size: size, inside: inside, button: button },
        React.createElement(TextField, { id: id, label: caption, helperText: tooltip, value: value, variant: "outlined", disabled: disabled, InputProps: inputProps, size: big ? 'medium' : 'small', fullWidth: inside, onChange: onValueChange })));
};
TextInput.defaultProps = {
    size: 'small',
    big: false,
    tooltip: '',
    suffix: undefined,
    contentType: 'text',
    inside: false,
    disabled: false,
    button: false,
    onChange: undefined,
};
export default TextInput;
//# sourceMappingURL=TextInput.js.map